import { useEffect, useRef } from "react";
import { API, api } from "@/lib/api";

const EVENTS = ["message", "conversation", "lead_reassigned", "lead_updated", "notification"];

export const useRealtime = (onEvent) => {
  const handler = useRef(onEvent);
  handler.current = onEvent;

  useEffect(() => {
    let es = null;
    let timer = null;
    let closed = false;
    const connect = async () => {
      try {
        const { data } = await api.post("/stream/ticket");
        if (closed) return;
        es = new EventSource(`${API}/stream?ticket=${encodeURIComponent(data.ticket)}`);
        EVENTS.forEach((t) => es.addEventListener(t, (e) => handler.current(JSON.parse(e.data))));
        es.onerror = () => { es.close(); if (!closed) timer = setTimeout(connect, 4000); };
      } catch {
        if (!closed) timer = setTimeout(connect, 8000);
      }
    };
    connect();
    return () => { closed = true; clearTimeout(timer); es?.close(); };
  }, []);
};
